"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("../utils");

require("./style.scss");

var getResultImg = function getResultImg(h, status) {
  return h("svg-icon", {
    "attrs": {
      "iconName": "fe-".concat(status)
    }
  });
};

var FeResult = {
  name: 'FeResult',
  functional: true,
  render: function render(h, context) {
    var extraRender = (0, _utils.getComponentFromProp)(context, 'extra');
    var _context$props = context.props,
        title = _context$props.title,
        subTitle = _context$props.subTitle,
        status = _context$props.status;
    return h("section", {
      "class": "fe-result fe-result-".concat(status)
    }, [h("div", {
      "class": "fe-result-img"
    }, [getResultImg(h, status)]), h("div", {
      "class": "fe-result-title"
    }, [title]), h("div", {
      "class": "fe-result-subtitle"
    }, [subTitle]), extraRender ? h("div", {
      "class": "fe-result-extra"
    }, [extraRender]) : null]);
  }
};

FeResult.install = function (Vue) {
  Vue.component(FeResult.name, FeResult);
};

var _default = FeResult;
exports.default = _default;